import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { STORAGE_KEYS } from '../components/dynamic-inputs/util/constants';

@Injectable({ providedIn: 'root' })
export class CaptchaStorageService {
  private token$ = new BehaviorSubject<string | null>(null);

  setToken(token: string): void {
    this.token$.next(token);
  }

  getToken(): string | null {
    return this.token$.value || localStorage.getItem(STORAGE_KEYS.CAPTCHA_RESPONSE);
  }

  watch(): Observable<string | null> {
    return this.token$.asObservable();
  }
}
